import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import {injectIntl} from 'react-intl'
import LoadingSpinner from "../../common/spinner/loading.component.jsx";
import {Redirect} from "react-router";
const queryString = require('query-string')

class CreateQuoteFromOrderRedirect extends Component {

    constructor(props, context) {
        super(props, context)
        const uri = queryString.parse(this.props.location.search)
        this.state = {
            externalId: uri.externalId,
            quoteId: '',
            loading: true,
        }
    }

    componentDidMount() {
        AppContext.getApiClient().post('/quotes/from-external-order', {
            integrationKey: 'zendesk-sell',
            externalId: this.state.externalId,
        }).then(res => {
            this.setState({
                loading: false,
                quoteId: res.id,
            })
        })

    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner />
        }
        return <Redirect to={{ pathname: `/quotes/${this.state.quoteId}/edit` }} />
    }
}

export default injectIntl(CreateQuoteFromOrderRedirect)





// WEBPACK FOOTER //
// ./src/embed/zendesk-sell/createquotefromorder.component.jsx